<template>
  <div>
    <v-card v-if="student && requirement">
      <v-card-title>{{ student.firstName }} {{ student.lastName }}</v-card-title>
      <v-card-subtitle>{{requirement.name}}</v-card-subtitle>
      <v-card-text>
        <v-select
          v-model="submissionMethod"
          :items="submissionMethods"
          label="Submission Method"
        ></v-select>
        <v-text-field
          v-if="requirement.type == 'Vaccination'"
          v-model="forDoseNumber"
          label="Dose Number"
          :required="false"
        />
        <v-textarea v-model="notes"/>
        <image-upload maxSize="52428800" v-model="files"/>
      </v-card-text>
      <v-card-actions>
        <v-btn>Submit</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { getStudent } from "@/services/student";
import { getRequirement } from "@/services/requirement";

export default {
  data: () => {
    return {
      submissionMethod: 'In-person',
      submissionMethods: ['Email', 'In-person', 'Online'],
      student: null,
      requirement: null,
      notes: null,
      files: null,
    };
  },
  mounted() {},
  created() {
    this.id = this.$route.params.id;
    this.requirementId = this.$route.params.requirementId;
    this.setInstance();
    this.$emit("showParent", false);
  },
  methods: {
    setInstance() {
      getStudent(this.id)
        .then(response => {
          this.selectedStudent = response.data;
        })
        .catch(() => {
          this.addErrorMessage("Error loading student");
        });
      getRequirement(this.requirementId)
        .then(response => {
          this.requirement = response.data;
        })
        .catch(() => {
          this.addErrorMessage("Error loading requirement");
        });
    },
  }
};
</script>

<style></style>
